
















import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { BarcodeStyle, BarcodeKinds, QrCodeStyle } from "../../../../domain/format/objects";
import { default as QrCodeStyleEditor } from "./QrCodeStyleEditor.vue";

@Component({
  components: {
    OptionDropDownSelector,
    QrCodeStyleEditor,
  }
})

export default class BarcodeStyleEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: BarcodeStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: BarcodeStyle) => T, defaultValue: T) => T;
  
  get kind(): BarcodeKinds {
    return this.readPropertyOrDefault(s => s.kind, undefined);
  }

  set kind(value: BarcodeKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  get separator(): string {
    return this.readPropertyOrDefault(s => s.separator, undefined);
  }

  set separator(value: string) {
    this.writePropertyWhenValid(s => s.separator = value);
  }

  get qrCodeStyle(): QrCodeStyle {
    return this.readPropertyOrDefault(s => s.qrCode, undefined);
  }

  set qrCodeStyle(value: QrCodeStyle) {
    this.writePropertyWhenValid(s => s.qrCode = value);
  }

  kindOptions: StandardOption<number>[] = [
    new StandardOption<number>("QRコード", BarcodeKinds.Qr),
    new StandardOption<number>("CODE-128", BarcodeKinds.Code128),
    new StandardOption<number>("NW-7", BarcodeKinds.Nw7),
  ];
}
